import { render, staticRenderFns } from "./EnIyiSatilanUrunler.vue?vue&type=template&id=1a6c096c&scoped=true"
import script from "./EnIyiSatilanUrunler.vue?vue&type=script&lang=js"
export * from "./EnIyiSatilanUrunler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c096c",
  null
  
)

export default component.exports